
import apiProxy from './api-proxy-inst';

class AuthApi {
  loginByEmail(args) {
    return apiProxy.requestPublic('/authentication_email/do', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  forgotByEmail(args) {
    return apiProxy.requestPublic('/user_password_reset_url/send_to_email', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  dataPic(args) {
    return apiProxy.requestPublic('/captcha_image/get', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  successDataPic (args) {
    return apiProxy.requestPublic('/captcha/verify', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  getZhuCeCustomer (args) {
    return apiProxy.requestPublic('/user_customer/register', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  getZhuCeDealer (args) {
    return apiProxy.requestPublic('/user_dealer/register', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  getUserEmail (args) {
    return apiProxy.requestPublic('/user_registering_email/validate', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  changePassword (args) {
    return apiProxy.request('/cur_user_password/change', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  modifyUserInformation (args) {
    return apiProxy.request('/cur_user_info/change', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  erpInstList (args) {
    return apiProxy.request('/cur_user_erpapp_inst/list', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  erpAppInstList (args) {
    return apiProxy.request('/cur_user_erpapp_inst/count', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  orderUserList(args) {
    return apiProxy.request('/cur_user_erpapp_inst_order/list', args).then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }

  renew() {
    return apiProxy.request('/authentication/renew').then(data => {
      if (data.succeeded) {
        data.certificate = apiProxy.getCertificate();
      }
      return data;
    });
  }
}

export default new AuthApi();
